'use client'

import { BUTTON_VARIANT } from '@fukku/button/Button.types'
import { ButtonIconTransparent } from '@fukku/button/Icon/Transparent'
import { IconPauseL } from 'icons/components/IconPauseL'
import { IconPlayL } from 'icons/components/IconPlayL'
import { useContext } from 'react'

import { MarqueeContext } from '../../../../../components/Marquee/MarqueeProvider'

import styles from './HeroBannerPrimaryLines.module.scss'

interface AnimationButtonProps {
	readonly titles: {
		play: string
		pause: string
	}
}

export const AnimationButton = ({ titles }: AnimationButtonProps) => {
	const { isAnimationPaused, toggleAnimation } = useContext(MarqueeContext)

	return (
		<ButtonIconTransparent
			variant={BUTTON_VARIANT.INVERSE}
			onClick={(e) => {
				e.preventDefault()
				e.stopPropagation()
				toggleAnimation()
			}}
			className={styles.pauseButton}
			title={isAnimationPaused ? titles.play : titles.pause}
		>
			{isAnimationPaused ? <IconPlayL /> : <IconPauseL />}
		</ButtonIconTransparent>
	)
}
